// ==================== SHIFT AVAILABILITY MANAGEMENT APIs ====================

const bp = "/bp";

// Create employee availability record
export const create_employee_availability = async (data, success) => {
  try {
    const response = await fetch(`${bp}/create_employee_availability`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === "success") {
      success(result);
    } else {
      console.error("Error creating availability:", result.message);
    }
    return result;
  } catch (error) {
    console.error("Error in create_employee_availability:", error);
    throw error;
  }
};

// Get employee availability records
export const get_employee_availability = async (params, success) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await fetch(`${bp}/get_employee_availability?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    });
    const result = await response.json();
    if (result.status === "success") {
      success(result);
    } else {
      console.error("Error fetching availability:", result.message);
    }
    return result;
  } catch (error) {
    console.error("Error in get_employee_availability:", error);
    throw error;
  }
};

// Delete employee availability record
export const delete_employee_availability = async (availability_id, success) => {
  try {
    const response = await fetch(`${bp}/delete_employee_availability`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
      body: JSON.stringify({ availability_id }),
    });
    const result = await response.json();
    if (result.status === "success") {
      success(result);
    } else {
      console.error("Error deleting availability:", result.message);
    }
    return result;
  } catch (error) {
    console.error("Error in delete_employee_availability:", error);
    throw error;
  }
};

// Get employee shift preferences
export const get_employee_preferences = async (employee_id, success) => {
  try {
    const response = await fetch(`${bp}/get_employee_preferences?employee_id=${employee_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    });
    const result = await response.json();
    if (result.status === "success") {
      success(result);
    } else {
      console.error("Error fetching preferences:", result.message);
    }
    return result;
  } catch (error) {
    console.error("Error in get_employee_preferences:", error);
    throw error;
  }
};

// Update employee shift preferences
export const update_employee_preferences = async (data, success) => {
  try {
    const response = await fetch(`${bp}/update_employee_preferences`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === "success") {
      success(result);
    } else {
      console.error("Error updating preferences:", result.message);
    }
    return result;
  } catch (error) {
    console.error("Error in update_employee_preferences:", error);
    throw error;
  }
};
